import React from 'react';
import roles from 'helpers/roles';
import { withTranslation } from 'react-i18next';
import getReportFileName from 'helpers/getReportFileName';

import BaseBrandReport from './BaseBrandReport';

class FoodCost extends React.Component {
  render() {
    const { t } = this.props;
    const title = t('reports.reportFoodCost');

    return (
      <BaseBrandReport
        title={title}
        excelUrl="reports/food-cost"
        fileName={getReportFileName(title)}
        role={roles.ROLE_SHOW_REPORT_FOOD_COST}
        pdfAvailable={false}
        excelAvailable={true}
        previewXlsxAvailable={true}
        archiveReportNames={['FOOD_COST']}
        dateType="single"
      />
    );
  }
}

export default withTranslation()(FoodCost);
